Vue.component('mod-logs', {
  template: templates.modLogs,
  data() {
    return {
      model: {
        logs: [],
        page: {
            current: 1,
            max: 0,
            limit: 5,
            count: 0 
        },
        isAdmin: false,
         option: [
            { value: 10, name: '10' },
            { value: 20, name: '20' },
            { value: 50, name: '50' },
            { value: 100, name: '100' }
        ],
        hasResult: false,
        isLoading: false,
      },
      cancelTokenSource: null
    }
  },
  mounted() {
    const c = this;
    c.get(c.model.page.current);
    c.connect();
  },
  beforeDestroy() {
    const c = this;

    if (c.ws) {
      c.ws.close();
    }

    if (c.cancelTokenSource) {
      c.cancelTokenSource.cancel('Request canceled due to component destruction.');
    }
  },
  methods: {
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl());

      c.ws.onmessage = (event) => {
        const messageData = event.data;

        try {
          const parsedData = JSON.parse(messageData);
        } catch (error) {
          console.error('Error parsing message data:', error);
        }
      };

      c.ws.onopen = () => {
        console.log('WebSocket connection established');
      };

      c.ws.onclose = () => {
        console.log('WebSocket connection closed');
      };
    },
    get(page) {
        const c = this;

        if (c.cancelTokenSource) {
          c.cancelTokenSource.cancel('Previous request canceled.');
        }
  
        c.cancelTokenSource = axios.CancelToken.source();

        userService.getModLogs({ page: page, limit: c.model.page.limit,cancelToken: c.cancelTokenSource.token})
        .then(function (response) {
            let logs = response.data.data;
            const updatedLogs = c.updateLogs(logs, response.data.isAdmin);
            c.model.logs = updatedLogs
            c.model.page.current = response.data.page;
            c.model.page.max = response.data.totalPages; 
            c.model.page.count = response.data.total;
            c.model.isAdmin = response.data.isAdmin;

            if(logs.length > 0){
              c.model.hasResult = true
            }
 
            c.model.isLoading = true

            console.log(logs)

        })
        .catch(function (error) {
            console.error(error);
            c.model.hasResult = false
            c.model.isLoading = true
        });
    },
    nextPage() {
        const c = this;
        if (c.model.page.current < c.model.page.max) {
        c.get(c.model.page.current + 1);
        }
    },
    prevPage() {
        const c = this;
        if (c.model.page.current > 1) {
        c.get(c.model.page.current - 1);
        }
    },
    goToPage(page) {
        const c = this;
        if (page >= 1 && page <= c.model.page.max) {
        c.get(page);
    }
    },
    selectedOption(){
        const c = this; 
        c.get(c.model.page.current);
    },
    updateLogs(logs, isAdmin) {
        const updatedLogs = logs.map(log => {
            let additionalInfo = '';
            let userMod = '';
            if(isAdmin){
              userMod = '('+ log.userMod[0].twitchDisplayName + ')';
            }
            // Check if teamBattle is not null
            if (log.modAdded !== null) {
              additionalInfo = `${log.modAdded[0].twitchDisplayName} ${log.log} `;
            }
            if (log.teamBattle !== null) {
                const team1DisplayNames = log.teamBattle.team1.map(member => 
                    member.user[0].twitchDisplayName
                );
                const team2DisplayNames = log.teamBattle.team2.map(member => 
                    member.user[0].twitchDisplayName
                );

                let playerTeam1;
                let playerTeam2;
               

                if(log.teamBattle.isSquad){
                    playerTeam1 = '('+ log.teamBattle.playerTeam1 + ')';
                    playerTeam2 = '('+ log.teamBattle.playerTeam2 +')';
                }

                 if(log.log === 'cancel_team_battle'){
                    additionalInfo = `${userMod} Team Battle Cancelled - ` + log.teamBattle.type + ` with ${log.teamBattle.isSquad ? playerTeam1 : ''} ${team1DisplayNames} vs ${log.teamBattle.isSquad ? playerTeam2 : ''} ${team2DisplayNames}`   ;
                 }
                 else if(log.log === 'requeue_team_battle'){
                    additionalInfo = `${userMod} Team Battle Requeue - ` + log.teamBattle.type + ` with ${log.teamBattle.isSquad ? playerTeam1: ''} ${team1DisplayNames} vs ${log.teamBattle.isSquad ? playerTeam2 : ''} ${team2DisplayNames}`   ;
                 }
                 else{
                    additionalInfo = `${userMod} Team Battle Started - mode: ` + log.teamBattle.type + ` with ${log.teamBattle.isSquad ?playerTeam1 : ''} ${team1DisplayNames} vs ${log.teamBattle.isSquad ? playerTeam2: ''} ${team2DisplayNames}`   ;
                 }

                
            }
            // Check if singleBattle is not null
            if (log.singleBattle !== null) {
                let cards1 = '('+ log.singleBattle.user1Cards + ')';
                let cards2 = '('+ log.singleBattle.user2Cards + ')';
                console.log(log)
                if(log.log === 'cancel_single_battle'){
                  additionalInfo = `${userMod}  Cancelled Battle between: ${cards1} ${log.singleBattle.user1TwitchDisplayName} and ${cards2} ${log.singleBattle.user2TwitchDisplayName}  `;
                }
                else if(log.log === 'requeue_single_battle'){
                additionalInfo = `${userMod} Single Battle Requeued between: ${cards1} ${log.singleBattle.user1TwitchDisplayName} and ${cards2} ${log.singleBattle.user2TwitchDisplayName}  `;
                }
                else{
                  additionalInfo = `${userMod} Single Battle started between: ${cards1} ${log.singleBattle.user1TwitchDisplayName} and ${cards2} ${log.singleBattle.user2TwitchDisplayName}  `;
                }
                
            }
            // Check if packs is not null
            if (log.packs !== null) {

                const packNames = log.packs.name
                const userName = log.packs.twitchDisplayName[0].twitchDisplayName

                if(log.log === 'queue'){
                  additionalInfo = userMod + ' Pack open on queue: ' + packNames + ' to ' + userName;
                  
                }
                else if(log.log === 'give pack'){
                  additionalInfo = userMod + ' Packs given: ' + packNames + ' to ' + userName;
                }
                else if(log.log === 'give chest'){
                  additionalInfo = userMod + ' Chest given: ' + packNames + ' to ' + userName;
                }
                else if(log.log === 'cancelled'){
                  additionalInfo = userMod + ' Packs cancelled: ' + packNames + ' to ' + userName;
                }
                else if(log.log === 'packs_to_hq'){
                  additionalInfo = userMod + ' Packs sent to user HQ: ' + packNames + ' to ' + userName;
                }
                else{
                  additionalInfo = userMod + ' Pack open: ' + packNames + ' to ' + userName;
                }
       
            }

            if (log.key !== null) {
              const keyName = log.key.name
              const userName = log.key.twitchDisplayName[0].twitchDisplayName

              if(log.log === 'give keys'){
                additionalInfo = userMod + 'Keys Given: ' + keyName + ' to ' + userName;
              }
            }
    
            if (additionalInfo) {
                return {
                    ...log,
                    log: additionalInfo.trim(),
                    logType: log.log // Store original log type for categorization
                };
            }
            return {
                ...log,
                logType: log.log
            };
        });
        return updatedLogs;
    },
    getLogIcon(log) {
        const logType = log.logType || log.log || '';
        
        if (logType.includes('pack') || logType.includes('Pack') || log.packs !== null) {
            if (logType.includes('queue')) return 'bi-hourglass-split';
            if (logType.includes('cancelled')) return 'bi-x-circle';
            if (logType.includes('give')) return 'bi-gift';
            if (logType.includes('HQ') || logType.includes('hq')) return 'bi-box-arrow-right';
            return 'bi-box';
        }
        if (logType.includes('chest') || logType.includes('Chest')) {
            return 'bi-treasure';
        }
        if (logType.includes('battle') || logType.includes('Battle')) {
            if (logType.includes('cancel')) return 'bi-x-octagon';
            if (logType.includes('requeue')) return 'bi-arrow-repeat';
            if (logType.includes('Team')) return 'bi-people';
            return 'bi-sword';
        }
        if (logType.includes('key') || logType.includes('Key') || log.key !== null) {
            return 'bi-key';
        }
        return 'bi-info-circle';
    },
    getLogTypeLabel(log) {
        const logType = log.logType || log.log || '';
        
        if (logType.includes('pack') || logType.includes('Pack') || log.packs !== null) {
            if (logType.includes('queue')) return 'Pack Queue';
            if (logType.includes('cancelled')) return 'Pack Cancelled';
            if (logType.includes('give')) return 'Pack Given';
            if (logType.includes('HQ') || logType.includes('hq')) return 'Pack Sent';
            return 'Pack Opened';
        }
        if (logType.includes('chest') || logType.includes('Chest')) {
            return 'Chest Given';
        }
        if (logType.includes('battle') || logType.includes('Battle')) {
            if (logType.includes('cancel')) return 'Battle Cancelled';
            if (logType.includes('requeue')) return 'Battle Requeued';
            if (logType.includes('Team')) return 'Team Battle';
            return 'Single Battle';
        }
        if (logType.includes('key') || logType.includes('Key') || log.key !== null) {
            return 'Key Given';
        }
        return 'Transaction';
    },
    getLogTypeClass(log) {
        const logType = log.logType || log.log || '';
        
        if (logType.includes('cancel') || logType.includes('Cancelled')) {
            return 'log-type-cancelled';
        }
        if (logType.includes('requeue') || logType.includes('Requeue')) {
            return 'log-type-requeue';
        }
        if (logType.includes('give') || logType.includes('Given')) {
            return 'log-type-given';
        }
        if (logType.includes('pack') || log.packs !== null) {
            return 'log-type-pack';
        }
        if (logType.includes('battle') || log.teamBattle !== null || log.singleBattle !== null) {
            return 'log-type-battle';
        }
        return 'log-type-default';
    },
    getLogTypeBadgeClass(log) {
        const logType = log.logType || log.log || '';
        
        if (logType.includes('cancel') || logType.includes('Cancelled')) {
            return 'badge-cancelled';
        }
        if (logType.includes('requeue') || logType.includes('Requeue')) {
            return 'badge-requeue';
        }
        if (logType.includes('give') || logType.includes('Given')) {
            return 'badge-given';
        }
        if (logType.includes('pack') || log.packs !== null) {
            return 'badge-pack';
        }
        if (logType.includes('battle') || log.teamBattle !== null || log.singleBattle !== null) {
            return 'badge-battle';
        }
        if (logType.includes('key') || log.key !== null) {
            return 'badge-key';
        }
        return 'badge-default';
    },
    formatDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    },
    formatTime(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        const options = { hour: '2-digit', minute: '2-digit', second: '2-digit' };
        return date.toLocaleTimeString('en-US', options);
    },
    getVisiblePages() {
        const c = this;
        const current = c.model.page.current;
        const max = c.model.page.max;
        const pages = [];
        
        if (max <= 7) {
            // Show all pages if 7 or fewer
            for (let i = 1; i <= max; i++) {
                pages.push(i);
            }
        } else {
            // Always show first page
            pages.push(1);
            
            if (current <= 4) {
                // Near the start
                for (let i = 2; i <= 5; i++) {
                    pages.push(i);
                }
                pages.push('...');
                pages.push(max);
            } else if (current >= max - 3) {
                // Near the end
                pages.push('...');
                for (let i = max - 4; i <= max; i++) {
                    pages.push(i);
                }
            } else {
                // In the middle
                pages.push('...');
                for (let i = current - 1; i <= current + 1; i++) {
                    pages.push(i);
                }
                pages.push('...');
                pages.push(max);
            }
        }
        
        return pages;
    },
  },
  computed: {
    pageNumbers() {
        const c = this;
        const pages = [];
        for (let i = 1; i <= c.model.page.max; i++) {
        pages.push(i);
        }
        return pages;
    }
  }
});
